import React from 'react';
import './Pages.css';

const SupportPage = () => {
  const handleLiveChat = () => {
    alert(' Support team is available 24/7.\n\nYou can reach us at:\n formerisaac@gmail.com\n📞 +233 (0) 24 680 4253\n Denu Tokor, Near St. Pauls Senior High School');
  };

  return (
    <div className="container fade-in-up">
      <div className="section-title">Support Center</div>
      
      <div className="support-hero">
        <i className="fas fa-headset"></i>
        <h3>How can we help you?</h3>
        <p className="justify-text">We offer dedicated player support, responsible gaming resources, and transparency reports. Our team is here to assist with any questions regarding the company, our mission, or future plans. All inquiries are handled with care and confidentiality.</p>
        
        <div className="values-grid support-grid">
          <div className="value-card">
            <i className="fas fa-question-circle"></i>
            <h3>FAQ</h3>
            <p className="justify-text">Quick answers about our lottery operations, integrity, and payout processes in GH₵.</p>
          </div>
          <div className="value-card">
            <i className="fas fa-user-shield"></i>
            <h3>Responsible Play</h3>
            <p className="justify-text">Tools and limits to ensure a healthy and enjoyable experience.</p>
          </div>
          <div className="value-card">
            <i className="fas fa-file-alt"></i>
            <h3>NLA Transparency</h3>
            <p className="justify-text">Audit reports and licensing details available from the National Lottery Authority.</p>
          </div>
        </div>

        <div className="support-contact">
          <p><i className="fas fa-phone"></i> Call us: +233 (0) 24 680 4253</p>
          <p><i className="fas fa-envelope"></i> Email: formerisaac@gmail.com</p>
          <p><i className="fas fa-building"></i> Visit: Denu Tokor, Near St. Paul's SHS</p>
        </div>
        
        <button className="btn-primary" onClick={handleLiveChat}>
          <i className="fas fa-comment-dots"></i> Start Live Chat
        </button>
      </div>
    </div>
  );
};

export default SupportPage;